import axios from 'axios';

import {
    ApiPortalFile,
    ApiSpec,
    ApiSpecS3UploadResult,
    SaveApiSpecResponse
} from '../../../schemas/apiSpec/f1ApiSpec.schema';

export async function getListApiSpecs() {
    return await axios.get<ApiSpec[]>('v1/api-specs', {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('MM_APPLICATION')
        }
    });
}

export async function getApiSpec(id: string) {
    return await axios.get<ApiSpec>('v1/api-specs/' + id, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('MM_APPLICATION')
        }
    });
}

export async function createApiSpec(apiSpec: ApiSpec[]) {
    await axios.post('v1/api-specs', apiSpec, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('MM_APPLICATION')
        }
    });
}

export async function getApiSpecFiles(apiGroup: string, apiName: string) {
    return await axios.get<ApiPortalFile[]>('v1/api-spec/files', {
        params: { apiGroup, apiName },
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('MM_APPLICATION')
        }
    });
}

export async function uploadApiSpecFiles(
    files: File[],
    apiGroup: string,
    apiName: string,
    uploadBy: string
) {
    const formData = new FormData();
    files.forEach(f => formData.append('files', f));
    formData.append('apiGroup', apiGroup);
    formData.append('apiName', apiName);
    formData.append('uploadBy', uploadBy);

    return await axios.post<ApiSpecS3UploadResult[]>('v1/api-spec/upload-file', formData, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('MM_APPLICATION')
        }
    });
}
